<template>
    <div class="numeric-updown">
        <div class="counter d-flex flex-row justify-content-between">
            <button v-if="buttons" :disabled="disable || minDisable || min == C.Int(value)" @click="down" :class="['inverse-' + color]" class="decrease btn btn-light btn-xs p-0 radius-sm me-1 me-sm-2 d-flex justify-content-center align-items-center">
                <i class="icon icon-minus px-2"></i>
            </button>
            <div class="d-flex align-items-center" v-if="isText">
                <template v-if="textType == 1">
                    <span class="numberInput text-center fs-3" :class="['text-' + color]">{{ value }}</span>
                </template>
                <template v-if="textType == 2">
                    <span class="numberInput text-center fs-3" :class="['text-' + color]">{{ timeShow(value) }}</span>
                </template>
                <template v-else>
                    <span class="numberInput text-center fs-6" :class="['text-' + color]">{{ placeholder }}<span class="circle" v-if="value != ''">{{ value }}</span></span>
                </template>
            </div>
            <template v-else>
                <input type="text" :value="value" @input="onInput" @blur="onBlur" @focus="selectAll" class="numberInput form-control radius-sm value text-center fs-3 b-600" :class="['text-' + color]" style="min-width:45px;" :placeholder="placeholder" :readonly="disable">
            </template>            
            <button v-if="buttons" :disabled="disable || maxDisable || max == C.Int(value)" @click="up" :class="['inverse-' + color]" class="increase btn btn-light btn-xs radius-sm ms-1 ms-sm-2 d-flex justify-content-center align-items-center">
                <i class="icon icon-plus"></i>
            </button>
        </div>
    </div>
</template>
<script>
    import { reactive, toRefs, computed,  watch } from 'vue';
    import { appData, C } from '@/helpers/global';

    export default {
        name: "NumericUpDown",
        /*inheritAttrs: false,v-bind="$attrs"*/
        components: {
        },
        props: { 
            modelValue: {
                required: true
            }, 
            min: {
                type: Number,
                default: 0
            }, 
            max: {
                type: Number,
                default: 100
            },
            step: {
                type: Number,
                default: 1
            },
            buttons: {
                type: Boolean,
                default: true
            },
            placeholder: {
                type: String,
                default: ""
            },
            isText: {
                type: Boolean,
                default: false
            },
            textType: {
                default: 0,
            },
            disabled: {
                type: Boolean,
                default: false
            },
            minDisabled: {
                type: Boolean,
                default: false
            },
            maxDisabled: {
                type: Boolean,
                default: false
            },
            color: {
                type: String,
                default: "primary"
            }
        },
        emits: ["update:modelValue", "change"],
        setup(props, ctx) {
            const e = reactive({
                disable: props.disabled,
                minDisable: props.minDisabled,
                maxDisable: props.maxDisabled,
                value: computed({
                    get() {
                        if(props.placeholder != "" && C.Str(props.modelValue) == "0") {
                            return "";
                        }
                        return e.valid(props.modelValue);
                    },
                    set(value) {
                        const newValue = e.valid(value);
                        if (e.oldValue != newValue) {
                            e.oldValue = newValue;
                            ctx.emit("update:modelValue", newValue);
                        }
                    }
                }),
                onInput(event) {
                    event.target.value = e.valid(event.target.value)
                    e.value = event.target.value;
                },
                onBlur(event) {
                    event.target.value = e.valid(event.target.value)
                    e.value = event.target.value;
                },
                valid(value) {
                    let val = C.Int(C.Str(value).replace(/(?!^-)[^0-9]/g, ''));
                    if (props.min > val) {
                        val = props.min;
                        //ctx.emit("update:modelValue", val);
                    }
                    else if (props.max < val) {
                        val = props.max;
                        //ctx.emit("update:modelValue", val);
                    }
                    if(C.Str(val) != C.Str(value)) {
                        //ctx.emit("update:modelValue", val);
                    }
                    return val;
                },
                down() {
                    let val = C.Int(e.value);
                    e.value = e.valid(val - props.step);
                },
                up() {
                    let val = C.Int(e.value);
                    e.value = e.valid(val + props.step);
                },
                timeShow(val) {
                    return C.DoDouble(Math.floor(val / 60)) + ':' + C.DoDouble(val % 60);  
                },
                selectAll(event) {
                    event.target.select();
                },
            });
            watch(() => props.disabled, (n, o) => {
                if (n != o) {
                    e.disable = n;
                }
            });
            watch(() => props.minDisabled, (n, o) => {
                if (n != o) {
                    e.minDisable = n;
                }
            });
            watch(() => props.maxDisabled, (n, o) => {
                if (n != o) {
                    e.maxDisable = n;
                }
            });
            return { ...toRefs(e) };
        },
    };
</script>
<style scoped>
    .circle {
    min-width: 24px;
    height: 24px;
    padding: 0px;
    margin: 0px;
    line-height: 24px !important;
    margin-left: 8px !important;
    color: #fff;
    background-color: #9C27B0;
    font-size: 0.8rem;
    border-radius: 50%;
    }
</style>